import { ComponentProps } from 'react';
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { IValidationResult, ValidationErrorMessage, ValidationLCTypes } from '@diana/core';

const tooltipSlotProps: ComponentProps<typeof Tooltip>['slotProps'] = {
  popper: {
    sx: {
      [`.${tooltipClasses.tooltip}`]: {
        margin: '0!important',
        padding: '0!important',
        border: 'none!important',
      },
      [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
        marginTop: '2px',
      },
      [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
        marginBottom: '2px',
      },
      [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
        marginLeft: '2px',
      },
      [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
        marginRight: '2px',
      },
    },
  },
};

const typeMap: Record<IValidationResult['type'], ValidationLCTypes> = {
  error: ValidationLCTypes.ERROR,
  warning: ValidationLCTypes.WARNING,
};

export const ValidationTooltip = (
  props: Omit<TooltipProps, 'title'> & { validationResult?: IValidationResult | null },
) => {
  const { validationResult, children, ...tooltipProps } = props;

  return (
    <Tooltip
      title={
        <ValidationErrorMessage
          type={validationResult ? typeMap[validationResult.type] : undefined}
          message={validationResult?.message}
        />
      }
      placement="bottom-start"
      slotProps={tooltipSlotProps}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
};
